import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Finsight',
  code: 'finsight' as const,
  supportEmail: env('FINSIGHT_WEB___SUPPORT__EMAIL'),
  supportPhoneNumber: env('FINSIGHT_WEB___SUPPORT__PHONE'),
  hostname: `${ domain.finsightDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_FINSIGHT'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_FINSIGHT__GTM_ID'),
  },
  supportChatId: env('FRONT_APP__CHAT_ID_TENANT_FINSIGHT'),
  newissueEmail: `newissue@${ domain.finsightDomain }`,
  api: {
    external: `${ domain.protocol }//${ domain.finsightDomain }`,
    internal: {
      finsightWeb: env('FINSIGHT_WEB_WS__HOSTNAME_INTERNAL'),
      finsightStrats: env('FINSIGHT_STRATS_WS__HOSTNAME_INTERNAL'),
    },
  },
};

export default config;
